"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var crossStr = String.fromCharCode(215);

var RemoveComponent = function RemoveComponent(props) {
  var readOnly = props.readOnly,
      removeComponent = props.removeComponent,
      onClick = props.onClick,
      className = props.className;

  if (readOnly) {
    return _react["default"].createElement("span", null);
  }

  if (removeComponent) {
    var Component = removeComponent;
    return _react["default"].createElement(Component, props);
  }

  return _react["default"].createElement("a", {
    onClick: onClick,
    className: className,
    onKeyDown: onClick
  }, crossStr);
};

RemoveComponent.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  readOnly: _propTypes["default"].bool,
  removeComponent: _propTypes["default"].func
};
var _default = RemoveComponent;
exports["default"] = _default;